import React from "react";
import { Link } from "react-router-dom";
import { X, Plus, Minus, ArrowRight } from "lucide-react";
import { BookButton } from "../BookButton";
import { OpenNowBadge } from "../OpenNowBadge";

// Full-screen mobile accordion menu. Markup/behavior preserved from Nav.jsx.
export function MobileMenu({ nav, menuOpen, setMenuOpen, openSection, setOpenSection, slug }) {
  return (
    <div
      data-testid="mobile-menu"
      className={`fixed inset-0 z-[60] bg-espresso text-ivory transition-all duration-500 ${
        menuOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
      }`}
    >
      <div className="flex items-center justify-between h-20 px-6 border-b border-ivory/10">
        <span className="font-serif text-2xl">Psalm 30:2</span>
        <button data-testid="mobile-menu-close" onClick={() => setMenuOpen(false)} aria-label="Close menu">
          <X size={28} strokeWidth={1.4} />
        </button>
      </div>
      <nav className="flex flex-col px-7 py-6 overflow-y-auto h-[calc(100vh-5rem)]">
        <div className="mb-6 space-y-4">
          <BookButton label="Book a Visit" variant="brass" track_label="mobile-menu" className="w-full" testid="mobile-book-button" />
          <div onClick={() => setMenuOpen(false)}><OpenNowBadge light /></div>
        </div>
        {nav.map((item, i) => {
          const isOpen = openSection === i;
          return (
            <div key={item.label} className="border-b border-ivory/10">
              <button
                data-testid={`mobile-section-${slug(item.label)}`}
                onClick={() => setOpenSection(isOpen ? null : i)}
                className="w-full flex items-center justify-between py-4 font-serif text-2xl"
              >
                {item.label}
                {isOpen ? <Minus size={20} /> : <Plus size={20} />}
              </button>
              <div className={`overflow-hidden transition-all duration-400 ${isOpen ? "max-h-[600px] pb-4" : "max-h-0"}`}>
                <div className="flex flex-col gap-1 pl-1">
                  {(item.children || []).map((c, j) => (
                    <Link key={`${c.to}-${c.label}`} to={c.to} data-testid={`mobile-sub-${slug(item.label)}-${j}`} className="py-2.5 text-ivory/75 hover:text-ivory text-base">
                      {c.label}
                    </Link>
                  ))}
                  {item.viewAll && (
                    <Link to={item.viewAll.to} className="py-2.5 text-brass text-sm uppercase tracking-[0.14em] inline-flex items-center gap-2">
                      {item.viewAll.label} <ArrowRight size={13} />
                    </Link>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </nav>
    </div>
  );
}
